import { render, staticRenderFns } from "./FtuFooterTutorial.vue?vue&type=template&id=49b52403&scoped=true"
import script from "./FtuFooterTutorial.vue?vue&type=script&lang=js"
export * from "./FtuFooterTutorial.vue?vue&type=script&lang=js"
import style0 from "./FtuFooterTutorial.vue?vue&type=style&index=0&id=49b52403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b52403",
  null
  
)

export default component.exports